import { getFunctions } from 'firebase/functions';
import initFirebase from '../firebase';

const firebaseApp = initFirebase();
// Las Cloud Functions del proyecto viven en us-central1.
const firebaseFunctions = getFunctions(firebaseApp, 'us-central1');

export default firebaseFunctions;
